/**
 * Created by nivethika on 21-8-17.
 */
import { environment } from 'environments/environment';
import { ORGANIZATION_ADMIN, PROJECT_ADMIN, PROJECT_MONITOR, SYSTEM_ADMIN } from 'app/types/authority';



export const AUTH_TOKEN_COOKIE = 'oAtkn'; // use a lesss explicit name for auth token cookie

export const SYSTEM_MENU: Array<App.MenuItem> = ([{
  label: $localize`:@@global.menu.admin.main:System Administration`,
  iconFont: 'design',
  iconName: 'settings',
  link: '/core/admin',
  authorities: [SYSTEM_ADMIN],
  children: [{
    label: $localize`:@@global.menu.organizations:Organizations`,
    link: '/core/admin/organization',
  }].concat(environment.production ? [] : [{
    label: $localize`:@@global.menu.userManagement:User Management`,
    link: '/core/admin/user-management',
  }])
}, {
  label: $localize`:@@global.menu.organization.main:Organization Management`,
  iconFont: 'design',
  iconName: 'corporate_fare',
  link: '/core/organization',
  authorities: [SYSTEM_ADMIN, ORGANIZATION_ADMIN],
  children: [{
    label: $localize`:@@global.menu.studies:Studies`,
    link: '/core/organization/study/list',
  }, {
    label: $localize`:@@global.menu.staff:Staff`,
    link: '/core/organization/staff',
  }]
}, {
  label: $localize`:@@global.menu.studyManagement:Study Management`,
  iconFont: 'design',
  iconName: 'stacks',
  link: '/core/study',
  authorities: [SYSTEM_ADMIN, ORGANIZATION_ADMIN, PROJECT_ADMIN, PROJECT_MONITOR],
  children: [{
    label: $localize`:@@global.menu.participants:Participants`,
    link: '/core/study/participants',
  }, {
    label: $localize`:@@global.menu.auditLog:Audit Log`,
    link: '/core/study/audit-log',
  }]
}] as Array<App.MenuItem>).concat(environment.production ? [] : [{
  label: $localize`:@@global.menu.entities.main:Entities`,
  iconName: 'cast',
  link: '/core/entities',
  authorities: [SYSTEM_ADMIN],
  children: [{
    label: $localize`:@@global.menu.source:Source`,
    link: '/core/entities/source',
  }, {
    label: $localize`:@@global.menu.sourceType:Source Type`,
    link: '/core/entities/source-type',
  }, {
    label: $localize`:@@global.menu.sourceData:Source Data`,
    link: '/core/entities/source-data',
  }, {
    label: $localize`:@@global.menu.subject:Subject`,
    link: '/core/entities/subject',
  }]
}, {
  label: $localize`:@@global.menu.system.main:System Tools`,
  iconName: 'construction',
  link: '/core/system',
  authorities: [SYSTEM_ADMIN],
  children: [{
    label: $localize`:@@global.menu.oauth-clients:OAuth Clients`,
    link: '/core/system/oauth-client',
  }, {
    label: $localize`:@@global.menu.metrics:Metrics`,
    link: '/core/system/app-metrics',
  }, {
    label: $localize`:@@global.menu.health:Health`,
    link: '/core/system/app-health',
  }, {
    label: $localize`:@@global.menu.audits:Audits`,
    link: '/core/system/audits',
  }, {
    label: $localize`:@@global.menu.revisions:Revisions`,
    link: '/core/system/revisions',
  }, {
    label: $localize`:@@global.menu.logs:Logs`,
    link: '/core/system/logs',
  }, {
    label: $localize`:@@global.menu.apidocs:API`,
    link: '/core/system/docs',
    deps: ['apiDocsEnabled']
  }]
}]);